import { useGetClientByIdQuery } from '@entities/clients/rtk-query.ts';
import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { useClientAboutEditPageRedirect } from '@pages/clients/client-about-page/edit-page/helpers.ts';
import { useClientAboutPageRedirect } from '@pages/clients/client-about-page/helpers.ts';
import { EditAndDeleteDropdown } from '@widgets/shared/EditAndDeleteDropdown/index.ts';
import { PageBackButton } from '@features/common/PageBackButton/index.tsx';
import { ListBody, PageHead, PageTitle } from '@shared/ui/index.ts';
import DescriptionViewer from '@shared/ui/viewer-note-editor-content/description-viewer/index.tsx';
import { Loader } from '@src/library/components/common/index.ts';

export const ClientAboutPage = () => {
  const { clientId } = useParams();

  const {
    data: client,
    isLoading,
    isFetching,
  } = useGetClientByIdQuery(Number(clientId), { skip: !clientId });

  const { doRedirectOnPrevPage } = useClientAboutPageRedirect();
  const { doRedirectWithSavePageUrl } = useClientAboutEditPageRedirect();

  const bodyJSX = useMemo(() => {
    if (isLoading || isFetching) {
      return <Loader />;
    }
    if (client) {
      const clientDescription = client.description;
      if (clientDescription) {
        return <DescriptionViewer description={clientDescription} isAlwaysFull />;
      } else {
        return 'У клиента нет описания';
      }
    } else {
      return 'Не найден клиент';
    }
  }, [isLoading, isFetching, client]);

  return (
    <>
      <PageTitle title="О клиенте" />
      <PageHead
        Left={<PageBackButton onClick={() => doRedirectOnPrevPage('/clients/clients')} />}
        Right={
          client ? (
            <EditAndDeleteDropdown
              withDeleteButton={false}
              onEdit={() => doRedirectWithSavePageUrl(`/clients/clients/${client.id}/about/edit`)}
            />
          ) : undefined
        }
      />

      <ListBody>{bodyJSX}</ListBody>
    </>
  );
};
